// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","652":"service","797":"industry"}[chunkId] || chunkId) + "." + {"594":"594b5703","652":"6ba07f55","752":"c3151a66","797":"21cf2785"}[chunkId] + ".js";
};